<template>
    <div>
      <el-form :model="form" ref="form" label-width="70px" :inline="inline" :size="formSize">
        <el-form-item label="地区"
                      prop="code"
                      :rules="[
                      { required: true, message: '地区不能为空',trigger: 'blur'}
                      ]">
          <el-cascader
            @change="changeCity"
            class="citySelect"
            :options="cityOptions"
            change-on-select
            :props="props"
            v-model="codeC"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="地点" class="city-autocomplete"
                      prop="areaName"
                      :rules="[
                      { required: true, message: '地点不能为空',trigger: 'blur'}
                      ]">
          <el-autocomplete
            ref="content"
            popper-class="my-autocomplete"
            v-model="areaNameC"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入地点"
            @select="handleSelect"
            :trigger-on-focus="false">
            <template slot-scope="{ item }">
              <div class="name">{{ item.address }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
import city from 'assets/js/city'
import {_queryMapSuggestion} from '../utils/area'

export default {
  name: 'autocompleteInput',
  props: {
    // publishForm: {
    //   type: Object,
    //   default: function () {
    //     return {
    //       areaName: '',
    //       code: [],
    //       areaCode: ''
    //     }
    //   }
    // }
    // publishForm: Object,
    areaName: String,
    areaCode: [String, Number],
    code: Array,
    formSize: {
      type: String,
      default: 'medium'
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      suggestionArr: [],
      cityOptions: city,
      props: {
        value: 'code',
        label: 'label',
        children: 'cities'
      },
      areaNameC: '',
      codeC: [],
      form: {code: [], areaName: ''},
      timeout: null
    }
  },
  computed: {
  },
  watch: {
    areaNameC: {
      handler (val) {
        this.form.areaName = val
        this.$emit('update:areaName', val)
      }
    },
    codeC: {
      handler (val) {
        this.form.code = val
        this.$emit('update:code', val)
      }
    },
    areaCode: {
      handler (val) {
        this.form.adcode = val
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
          this.$refs['content'].focus()
          this.handleSelect(this.form)
        })
      },
      immediate: true
    },
    code: {
      handler (val) {
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
          this.$refs['content'].focus()
        })
        this.codeC = val
      },
      immediate: true
    },
    areaName: {
      handler (val) {
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
          this.$refs['content'].focus()
        })
        this.areaNameC = val
      },
      immediate: true
    }
    // publishForm: {
    //   handler (val) {
    //     this.suggestionArr = []
    //     this.$nextTick(() => {
    //       // this.$refs['form'].clearValidate()
    //       // this.$refs['content'].focus()
    //     })
    //     console.log(val)
    //     this.from = val
    //     console.log(this.from)
    //     this.handleSelect(val)
    //   },
    //   immediate: true,
    //   deep: true
    // }
    // areaCode: {
    //   handler (val) {
    //     this.suggestionArr = []
    //     this.$nextTick(() => {
    //       this.$refs['form'].clearValidate()
    //       this.$refs['content'].focus()
    //     })
    //     this.form.adcode = val
    //     this.handleSelect(this.form)
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  created () {

  },
  methods: {
    querySearchAsync (queryString, cb) {
      this.areaNameC = queryString.replace(/[^\u4E00-\u9FA5]/g, '')
      clearTimeout(this.timeout)
      let arr = _queryMapSuggestion(this.areaNameC)
      this.timeout = setTimeout(() => {
        cb(arr)
      }, 1000)
      // this.$emit('update:publishForm', this.form)
    },
    handleSelect (item) {
      if (this.wei.isNull(item.adcode)) {
        return
      }
      var adcode = item.adcode.toString()
      this.codeC = []
      if (adcode % 10000 === 0) {
        // console.log(pcaa['86'][adcode] + 'province')
        this.codeC = [adcode.substring(0, 2) + '0000']
      } else {
        var province = adcode.substring(0, 2) + '0000'
        // console.log(pcaa['86'][province] + 'province')
        var city = adcode.substring(0, 4) + '00'
        if (adcode % 100 === 0) {
          // console.log(pcaa[province][item.adcode] + 'city')
          this.codeC = [province, city]
        } else {
          this.codeC = [province, city, item.adcode.toString()]
          // console.log(pcaa[province][city] + 'city')
          // console.log(pcaa[city][item.adcode] + 'district')
        }
      }
      // this.$emit('update:publishForm', this.form)
    },
    changeCity () {
      // this.$emit('update:publishForm', this.form)
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.city-autocomplete
  .el-autocomplete
    width 100%
.citySelect
  display block !important
</style>
